import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { SCENARIO_API_URL } from "../../../config";
import { ModelScenarioShort } from "../types";

export const useModelScenarios = (model_id: number) => {
  return useQuery({
    queryKey: ["model", model_id, "scenarios"],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${SCENARIO_API_URL}/waves-scenario-manager-api/v1/scenarios/?model_id=${model_id}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelScenarioShort[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
